// src/layouts/CalendlyEmbed/CalendlyEmbed.js

import React from "react"
import styled from "styled-components"
import { InlineWidget } from "react-calendly"

const CalendlyEmbed = ({
  calendlySectionId,
  calendlyTopContent,
  calendlyEmbedUrl,
  calendlyCtaTitle,
  calendlyCtaLink,
  calendlyCtaLinkText,
}) => {
  return (
    <ContactSection id={calendlySectionId}>
      <div
        className="header-container"
        dangerouslySetInnerHTML={{ __html: calendlyTopContent }}
      />
      <div className="calendly-wrapper">
        <InlineWidget url={calendlyEmbedUrl} />
      </div>
      <h5>{calendlyCtaTitle}</h5>
      <p>
        <a target="_blank" rel="noreferrer" href={calendlyCtaLink}>
          {calendlyCtaLinkText}
        </a>
      </p>
    </ContactSection>
  )
}

const ContactSection = styled.section`
  max-width: 1170px;
  width: 100%;
  margin: 0 auto;
  background-color: #ffffff;
  padding: 60px 0px;
  .header-container {
    padding: 0 100px;
  }
  h2 {
    text-align: center;
    font: normal normal bold 60px/70px Nobel;
    letter-spacing: 0px;
    color: #2B2520;
    margin-top: 0;
  }
  h5 {
    text-align: center;
    font: normal normal bold 32px/36px Nobel;
    letter-spacing: 0px;
    color: #2b2520;
    margin: 10px 0;
  }
  p {
    margin: 0 auto;
    text-align: center;
    font: normal normal normal 20px/28px Work Sans;
    letter-spacing: 0px;
    color: #777c7c;
    max-width: 970px;
    &:last-child {
      margin-bottom: 0;
    }
    a {
      text-align: center;
      text-decoration: underline;
      font: normal normal normal 18px/28px Work Sans;
      letter-spacing: 0px;
      color: #c44c4a;
      margin-top
    }
  }
  .calendly-wrapper {
    position: relative;
    display: block;
    padding-top: 17%;

    iframe {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      border: none !important;
    }
  }
  @media (max-width: 999px) {
    .calendly-wrapper {
      padding-top: 40%;
    }
  }
  @media (max-width: 899px) {
    .calendly-wrapper {
      padding-top: 45%;
    }
  }
  @media (max-width: 815px) {
    .calendly-wrapper {
      padding-top: 48%;
    }
  }
  @media (max-width: 767px) {
    margin: 0 auto 50px;
    padding: 30px;
    .header-container {
      padding: 0;
      margin-bottom: 30px;
    }
    h2 {
      font: normal normal bold 32px/36px Nobel;
    }
    p {
      font: normal normal normal 16px/24px Work Sans;
    }
    .calendly-wrapper {
      padding-top: 52%;
    }
  }
  @media (max-width: 500px) {
    .calendly-wrapper {
      padding-top: 50%;
    }
  }
  @media (max-width: 375px) {
    margin: 0 auto 100px;

    .calendly-wrapper {
      padding-top: 75%;
    }
  }
`

export default CalendlyEmbed
